import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import landingpage from "../views/landingpage.vue";
/* eslint-disable */
// @ts-ignore
import AUTH from "../auth.js";
/* eslint-enable */
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "landingpage",
    component: landingpage
  },
  {
    path: "/learning",
    name: "Home",
    component: Home
  },
  {
    path: "/teachersignup",
    name: "TeacherSignUp",
    component: () => import("../views/Teacher/TeacherSignUp.vue"),
  },
  {
    path: "/studentsignup",
    name: "studentSignUp",
    component: () => import("../views/Student/studentSignUp.vue"),
  },
  {
    path: "/404",
    name: "NotFoundComponent",
    component: () => import("../views/404.vue"),
  },

  {
    path: "/login",
    name: "login",
    component: () => import("../views/Auth/login.vue"),
  },
  {
    path: "/forgetpassword",
    name: "forgetpassword",
    component: () => import("../views/Auth/ForgetPassword.vue"),
  },
  {
    path: "/activationcode",
    name: "activationCode",
    component: () => import("../views/Auth/activationCode.vue"),
  },
  {
    path: "/teacher/appointments",
    name: "teacherAppointments",
    component: () => import("../views/Teacher/teacherAppointments.vue"),
  },
  {
    path: "/student/appointments",
    name: "studentAppointments",
    component: () => import("../views/Student/studentAppointments.vue"),
  },
  {
    path: "/student/payment/:sessionId",
    name: "payment",
    component: () => import("../views/payments/payment.vue"),
  },
  {
    path: "/payments/redirect/:paymentId",
    name: "paymentRedirect",
    component: () => import("../views/payments/paymentRedirect.vue"),
  },
  {
    path: "/teachers",
    name: "teachers",
    component: () => import("../views/Teacher/teachers.vue"),
    beforeEnter: (to, from, next) => {
      if (AUTH.isLoggedIn()) {
        if (AUTH.type() == "Student") {
          next();
        } else {
          next("/");
        }
      } else {
        next("/");
      }
    }
  },
  {
    path: "/teachers/:id",
    name: "teacher-show",
    component: () => import("../views/Teacher/teacherShow.vue"),
  },
  {
    path: "/teacher/profilesettings",
    name: "teacherProfileShow",
    component: () => import("../views/Teacher/teacherProfileShow.vue"),
    beforeEnter: (to, from, next) => {
      if (AUTH.isLoggedIn()) {
        if (AUTH.type() == "Teacher") {
          next();
        } else {
          next("/login");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/student/profile",
    name: "studentProfile",
    component: () => import("../views/Student/studentProfile.vue"),
    beforeEnter: (to, from, next) => {
      if (AUTH.isLoggedIn()) {
        if (AUTH.type() == "Student") {
          next();
        } else {
          next("/");
        }
      } else {
        next("/");
      }
    }
  },
  {
    path: "/student/profilesettings",
    name: "studentProfileShow",
    component: () => import("../views/Student/studentProfileShow.vue"),
    beforeEnter: (to, from, next) => {
      if (AUTH.isLoggedIn()) {
        if (AUTH.type() == "Student") {
          next();
        } else {
          next("/");
        }
      } else {
        next("/");
      }
    }
  },
  {
    path: "/teacher/profile",
    name: "TeacherSchedule",
    component: () => import("../views/Teacher/teacherProfile.vue"),
    beforeEnter: (to, from, next) => {
      if (AUTH.isLoggedIn()) {
        if (AUTH.type() == "Teacher") {
          next();
        } else {
          next("/login");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/about",
    name: "About",
    component: () =>
      import("../views/About.vue")
  },
  {
    path: "/session/rules/:reservationId",
    name: "sessionRules",
    component: () =>
      import("../views/sessions/sessionRules.vue")
  },
  {
    path: "/session/:reservationId",
    name: "zoomSession",
    component: () =>
      import("../views/zoom/zoomSession.vue")
  },
  {
    path: "/meeting/:reservationId",
    name: "MeetingView",
    component: () =>
      import("../views/zoom/MeetingView.vue")
  },
  {
    path: "/teacher/thankyou/:sessionId",
    name: "sessionRatingTeacher",
    component: () =>
      import("../views/zoom/sessionRating.vue")
  },
  {
    path: "/student/thankyou/:sessionId",
    name: "sessionRatingStudent",
    component: () =>
      import("../views/zoom/sessionRating.vue")
  },
  {
    path: "/student/wallet",
    name: "studentWallet",
    component: () =>
      import("../views/payments/studentWallet.vue"),
    beforeEnter: (to, from, next) => {
      if (AUTH.isLoggedIn()) {
        if (AUTH.type() == "Student") {
          next();
        } else {
          next("/");
        }
      } else {
        next("/");
      }
    }
  },
  {
    path: "/market",
    name: "marketFront",
    component: () =>
      import("../views/market/marketFront.vue")
  },
  {
    path: "/market/login",
    name: "loginMarket",
    component: () =>
      import("../views/market/Auth/login.vue")
  },
  {
    path: "/market/register",
    name: "Registration",
    component: () =>
      import("../views/market/Auth/Registration.vue")
  },
  {
    path: "/market/profileSettings",
    name: "buyerProfileShow",
    component: () =>
      import("../views/market/buyerProfileShow.vue")
  },
  {
    path: "/market/activationcode",
    name: "MarketActivationCode",
    component: () => import("../views/market/Auth/activationCode.vue"),
  },
  {
    path: "/market/ForgetPassword",
    name: "ForgetPassword",
    component: () =>
      import("../views/market/Auth/ForgetPassword.vue")
  },
  {
    path: "/market/product/:product_id",
    name: "productPage",
    component: () =>
      import("../views/market/productPage.vue")
  },
  {
    path: "/market/Categories/:id?",
    name: "Categories",
    component: () =>
      import("../views/market/Categories.vue")
  },
  {
    path: "/market/wishlist",
    name: "wishlist",
    component: () =>
      import("../views/market/Auth/WishList.vue")
  },
  {
    path: "/market/addresses",
    name: "Addresses",
    component: () =>
      import("../views/market/Addresses.vue")
  },
  {
    path: "/market/cart",
    name: "Cart",
    component: () =>
      import("../views/market/Cart.vue")
  },
  {
    path: "/market/checkout",
    name: "Checkout",
    component: () =>
      import("../views/market/Checkout.vue")
  },
  {
    path: "/market/payments/redirect/:paymentId",
    name: "marketThankyou",
    component: () =>
      import("../views/market/thankyou.vue")
  },
  {
    path: "/market/offers",
    name: "Offers",
    component: () =>
      import("../views/market/offers.vue")
  },
  ///////////////////////////////////////////////
  {
    path: "/seller/registration",
    name: "SellerRegistration",
    component: () =>
      import("../views/Seller/SellerRegistration.vue")
  },
  {
    path: "/seller/profileSettings",
    name: "sellerProfileSettings",
    component: () =>
      import("../views/Seller/sellerProfileShow.vue")
  },
  {
    path: "/seller/activationCode",
    name: "activationCode",
    component: () =>
      import("../views/Seller/activationCode.vue")
  },
  {
    path: "/seller/login",
    name: "login",
    component: () =>
      import("../views/Seller/login.vue")
  },
  {
    path: "/seller/ForgetPassword",
    name: "ForgetPassword",
    component: () =>
      import("../views/Seller/ForgetPassword.vue")
  },
  {
    path: "/seller/Shop",
    name: "Shop",
    component: () =>
      import("../views/Seller/Shop.vue"),
    beforeEnter: (to, from, next) => {
      if (AUTH.isLoggedIn('seller')) {
        next();
      } else {
        next("/seller/login");
      }
    }
  },
  {
    path: "/seller/unapproved",
    name: "UnapprovedProduct",
    component: () =>
      import("../views/Seller/UnapprovedProduct.vue"),
    beforeEnter: (to, from, next) => {
      if (AUTH.isLoggedIn('seller')) {
        next();
      } else {
        next("/seller/login");
      }
    }
  },
  {
    path: "/seller/product/:product_id",
    name: "UnapprovedProduct",
    component: () =>
      import("../views/Seller/productPage.vue"),
    beforeEnter: (to, from, next) => {
      if (AUTH.isLoggedIn('seller')) {
        next();
      } else {
        next("/seller/login");
      }
    }
  },
  {
    path: "/policy",
    name: "websitePolicy",
    component: () => import("../views/policy/websitePolicy.vue"),
  },
  {
    path: "/terms",
    name: "TermOfUse",
    component: () => import("../views/policy/TermOfUse.vue"),
  },
  {
    path: "/contactus",
    name: "ContactUs",
    component: () => import("../views/contactUs.vue"),
  },
  {
    path: "*",
    name: "NotFoundComponent",
    component: () => import("../views/404.vue"),
  },
  {
    path: "/comingsoon",
    name: "comingSoon",
    component: () =>
      import("../views/comingSoon.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
